<!--
 * @Author: lijh(¯﹃¯*)
 * @Date: 2023-12-25 09:14:04
 * @LastEditors: lijh(¯﹃¯*)
 * @LastEditTime: 2024-01-04 16:41:20
 * @Description: 二次封装ElementUi表格
-->
<template>
  <el-table
    ref="table"
    :border="showBorder"
    :data="data"
    :stripe="stripe"
    :height="height"
    :cell-style="cellStyle"
    :row-style="rowStyle"
    :header-cell-style="headerCellStyle"
    :tooltip-effect="tipEffect"
    :size="size"
    align="center"
    @row-click="rowClick"
    @row-dblclick="rowDblclick"
    @selection-change="selectionChange"
    @sort-change="sortChange"
  >
    <el-table-column v-if="selection" type="selection" width="55">
    </el-table-column>
    <el-table-column
      v-if="showIndex"
      :label="indexLabel"
      sortable
      type="index"
      width="80"
      align="center"
    >
    </el-table-column>
    <template v-for="(item, index) in columns">
      <el-table-column
        v-if="!item.hidden"
        :key="index"
        :prop="item.prop"
        :label="item.label"
        :width="String(item.width)"
        :min-width="String(item.minWidth)"
        :show-overflow-tooltip="
          item.tooltip !== undefined ? item.tooltip : true
        "
        :align="item.align"
        :sortable="item.sortable"
      >
        <template slot-scope="scope">
          <slot
            v-if="item.showSlot"
            :name="`${item.prop}`"
            :scope="scope"
          ></slot>
          <template v-else>{{ scope.row[item.prop] }}</template>
        </template>
      </el-table-column>
    </template>

    <el-table-column
      v-if="showOperator"
      :show-overflow-tooltip="false"
      :width="operatorWidth"
      label="操作"
      align="center"
      label-width="120px"
    >
      <template slot-scope="scope">
        <slot name="default" :scope="scope"></slot>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
export default {
  name: "TableColumns",
  props: {
    data: {
      type: Array,
      default: () => []
    },
    columns: {
      type: Array,
      default: () => []
    },
    cellStyle: {
      type: Object,
      default: () => {}
    },
    rowStyle: {
      type: Object | Function,
      default: () => {}
    },
    headerCellStyle: {
      type: Object,
      default: () => {}
    },
    //是否展示操作栏
    showOperator: {
      type: Boolean,
      default: false
    },
    //操作栏宽度
    operatorWidth: {
      type: String,
      default: "100"
    },
    size: {
      type: String,
      default: ""
    },
    tipEffect: {
      type: String,
      default: "dark"
    },
    //是否展示边框
    showBorder: {
      type: Boolean,
      default: true
    },
    //是否展示序列
    showIndex: {
      type: Boolean,
      default: false
    },
    //是否展示Checkbox
    selection: {
      type: Boolean,
      default: false
    },
    //自定义序列label
    indexLabel: {
      type: String,
      default: "序号"
    },
    height: {
      type: String,
      default: "calc(100% - 40px)"
    },
    maxHeight: {
      type: String,
      default: "500"
    },
    stripe: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    rowClick(row, column, event) {
      this.$emit("row-click", row, column, event);
    },
    rowDblclick(row, column, event) {
      this.$emit("row-dblclick", row, column, event);
    },
    selectionChange(val) {
      this.$emit("selection-change", val);
    },
    sortChange(val) {
      this.$emit("sort-change", val);
    }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/common/DetailTable.vue